
import { Vue, Component } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';

@Component({
  components: {
    Viewer,
  },
})
export default class ImagePreviewModal extends Vue {
  visible = false;

  title = '图片预览';

  images: any[] = [];

  /**
   * 打开预览弹框
   * @param title 弹框标题
   * @param imageList 图片列表，支持以下格式：
   *   - string[]：URL 数组
   *   - { url: string }[]：对象数组
   *   - { source: string, thumbnail?: string, alt?: string }[]：v-viewer 完整格式
   */
  open(title: string, imageList: any[]) {
    this.title = title || '图片预览';
    this.images = this.normalizeImages(imageList);
    this.visible = true;
  }

  normalizeImages(list: any[]): any[] {
    if (!list || !list.length) return [];
    return list
      .map((item: any) => {
        if (typeof item === 'string') {
          return { source: item, thumbnail: item, alt: '' };
        }
        if (item.source) return item;
        if (item.url) {
          return { source: item.url, thumbnail: item.url, alt: item.alt || '' };
        }
        return null;
      })
      .filter(Boolean);
  }

  onClose() {
    this.visible = false;
    this.images = [];
  }
}
